import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    CHARGEBACKS_FAILURE,
    CHARGEBACKS_LOAD,
    CHARGEBACKS_SUCCESS,
    CHARGEBACKS_SUMMARY_FAILURE,
    CHARGEBACKS_SUMMARY_LOAD,
    CHARGEBACKS_SUMMARY_SUCCESS
} from './chargebacksActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                chargebacks: []
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_LOAD:
            newState = {
                ...state,
                chargebacks: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_SUCCESS:
            newState = {
                ...state,
                chargebacks: action.chargebacks,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_SUMMARY_LOAD:
            newState = {
                ...state,
                summary: {},
                error: null,
                summaryLoaded: false,
                summaryLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_SUMMARY_SUCCESS:
            newState = {
                ...state,
                summary: action.summary,
                summaryLoaded: true,
                summaryLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case CHARGEBACKS_SUMMARY_FAILURE:

            newState = {
                ...state,
                error: action.error,
                summaryLoaded: true,
                summaryLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getChargebacksEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'chargebacks')
);

export const getPages = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'count')
);

export const getIsChargebacksSummaryLoaded = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'summaryLoaded')
);

export const getIsChargebacksLoading = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'loading')
);

export const getChargebacks = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'chargebacks')
);

export const getChargebacksError = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'error')
);

export const getChargebacksErrorMessage = createSelector(
    getChargebacksError,
    (error) => get(error, 'message')
);

export const getChargebacksSummary = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'summary')
);

export const getIsChargebacksSummaryLoading = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'summaryLoading')
);

export const getChargebacksSummaryError = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'summaryError')
);

export const getChargebacksSummaryErrorMessage = createSelector(
    getChargebacksSummaryError,
    (entity) => get(entity, 'message')
);

export const getHasMore = createSelector(
    getChargebacksEntity,
    (entity) => get(entity, 'hasMore')
);
